import React, { lazy } from 'react';
import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";
import { frontendurls } from '../constants/FrontendURLs';
import constants from '../constants/Constants';
import { AdminRoute, StudentRoute } from './helper';
import SecondLayouts  from '../pages/common/SecondLayout';
import Layouts from '../pages/common/Layout';
const FilterImages = lazy(() => import('../pages/admin/images/FilterImages'));
const ViewWishlist = lazy(() => import('../pages/user/cart/ViewWishlist'));
const PageNotFound = lazy(() => import('../pages/common/pageNotFound/PageNotFound'));
const PendingRequestDetails = lazy(() => import('../pages/admin/manageRequest/PendingRequestDetails'));
const UserListing = lazy(() => import('../pages/admin/manageUser/UserListing'));
const PreviousRequestList = lazy(() => import('../pages/admin/manageRequest/PreviousRequestList'));
const AddEditImage = lazy(() => import('../pages/admin/images/AddEditImage'));
const Login = lazy(() => import('../pages/common/Login'));
const ListImages = lazy(() => import('../pages/admin/images/ListImages'));
const PendingRequestList = lazy(() => import('../pages/admin/manageRequest/PendingRequestList'));
const ViewCollections = lazy(() => import('../pages/user/cart/ViewCollections'));
const Register = lazy(() => import('../pages/user/Register'));
const AdminListing = lazy(() => import('../pages/admin/manageAdmin/AdminListing'));
const ForgotPassword = lazy(() => import('../pages/common/ForgotPassword'));
const ResetPassword = lazy(() => import('../pages/common/ResetPassword'));
const Dashboard = lazy(() => import('../pages/common/Dashboard'));
const Profile = lazy(() => import('../pages/common/Profile'));
const ListImagesUser = lazy(() => import('../pages/user/images/ListImagesUser'));
const ListBooks = lazy(() => import('../pages/admin/manageBooks/ListBooks'));
const ListCategories = lazy(() => import('../pages/admin/manageBooks/ListCategories'));
const TopRequestedImages = lazy(() => import('../pages/admin/manageRequest/TopRequestedImages'));
const UserWiseRequestList = lazy(() => import('../pages/admin/manageRequest/UserWiseRequestList'));
const AdminDashboard = lazy(() => import('../pages/user/dashboard/AdminDashboard'));
const PrivacyPolicy = lazy(() => import('../pages/common/PrivacyPolicy'));
const FAQs = lazy(() => import('../pages/common/FAQs'));

const routerBrowser = createBrowserRouter(
	createRoutesFromElements(
		<>
			{/*-------------------------- PUBLIC ROUTES --------------------------*/}
			<Route element={<SecondLayouts />}>
				<Route path={frontendurls.UserLogin} element={<Login />} />
				<Route path={frontendurls.AdminLogin} element={<Login />} />
				<Route path={frontendurls.ForgotPassword} element={<ForgotPassword />} />
				<Route path={frontendurls.ResetPassword} element={<ResetPassword />} />
				<Route path={frontendurls.Register} element={<Register />} />
			</Route>

			<Route element={<Layouts />}>
				{/* -------------------------- COMMON ROUTES (All Roles) -------------------------- */}
				<Route path="/" element={<Dashboard />} />
				<Route path={frontendurls.Home} element={<Dashboard />} />
				<Route path={frontendurls.Profile} element={<Profile />} />
				<Route path={frontendurls.ViewImages} element={<ListImagesUser />} />
				<Route path={frontendurls.PendingRequestDetails} element={<PendingRequestDetails />} />
				<Route path={frontendurls.PrivacyPolicy} element={<PrivacyPolicy />} />
				<Route path={frontendurls.FAQs} element={<FAQs />} />

				{/*-------------------------- STUDENT ONLY ROUTES --------------------------*/}
				<Route element={<StudentRoute />}>
					<Route path={frontendurls.ViewCollections} element={<ViewCollections />} />
					<Route path={frontendurls.ViewWishlist} element={<ViewWishlist />} />
					<Route path={frontendurls.MyRequests} element={<PreviousRequestList />} />
				</Route>

				{/*-------------------------- ADMIN ONLY ROUTES --------------------------*/}
				<Route element={<AdminRoute />}>
					<Route path={frontendurls.AddImage} element={<AddEditImage />} />
					<Route path={frontendurls.EditImage} element={<AddEditImage />} />
					<Route path={frontendurls.ListImages} element={<ListImages />} />
					<Route path={frontendurls.FilterImages} element={<FilterImages />} />
					<Route path={frontendurls.PendingRequests} element={<PendingRequestList />} />
					<Route path={frontendurls.AllPendingRequests} element={<PendingRequestList />} />
					<Route path={frontendurls.AdminListing} element={<AdminListing />} />
					<Route path={frontendurls.UserListing} element={<UserListing />} />
					<Route path={frontendurls.UserRequests} element={<UserWiseRequestList />} />
					<Route path={frontendurls.ImageRequests} element={<TopRequestedImages />} />
					<Route path={frontendurls.AdminDashboard} element={<AdminDashboard />} />
					<Route path={frontendurls.PreviousRequestList} element={<PreviousRequestList />} />
					<Route path={frontendurls.AllUserRequests} element={<PreviousRequestList />} />
					<Route path={frontendurls.ListBooks} element={<ListBooks />} />
					<Route path={frontendurls.ListCategories} element={<ListCategories />} />
				</Route>
			</Route>

			{/*-------------------------- 404 ROUTE --------------------------*/}
			<Route path="*" element={<PageNotFound />} />
		</>
	),
	{
		basename: constants.BaseUrl,
	}
);
export default routerBrowser;
